import { render, staticRenderFns } from "./Huizhoux.vue?vue&type=template&id=32d4456a&scoped=true&"
import script from "./Huizhoux.vue?vue&type=script&lang=js&"
export * from "./Huizhoux.vue?vue&type=script&lang=js&"
import style0 from "./Huizhoux.vue?vue&type=style&index=0&id=32d4456a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d4456a",
  null
  
)

export default component.exports